/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../login/login.component';
import { ConsignmentsComponent } from '../consignments/consignments.component';

const routes: Routes = [
  { path: 'login/:referrer/:file_name', component: LoginComponent },
  { path: 'consignments-list/:referrer/:file_name', component: ConsignmentsComponent }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class ConsignmentDetailRoutingModule { }
